/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { TOPOLOGY_ROOM } from "../rooms/RoomNameConstants";
import { setCenterGraph } from "../store/slice/centerGraphSlice";
import { ObjectClone } from "../utils/ObjectUtils";
import { changeRoomHandler } from "./ChangeRoomHandlers";
import {
    setPosition,
    setTopologyGraphData,
    setTopologyGraphFilter,
    setZoom
} from "../store/slice/roomSlices/topologyRoomSlice";
import store from "../store/store";

// const topologyRoomSetup = (selectedJob) => {
//     getTopologyRoomData({
//         selectedJob,
//         targetRoom: TOPOLOGY_ROOM
//     });
// }

export const handleGoToTopologyRoom = (selectedJob) => {
    const state = store.getState()
    const dispatch = store.dispatch

    const dataToCache = {
        key: "centerGraph",
        data: state.centerGraph,
        callback: (cachedData) => {
            dispatch(setCenterGraph(cachedData))
        },
    }

    changeRoomHandler(
        TOPOLOGY_ROOM,
        null,
        dataToCache
    )
}

export const handleSetZoom = (callback) => {
    const oldScale = store.getState()[TOPOLOGY_ROOM].graph.state.scale
    const newScale = callback(oldScale)
    store.dispatch(setZoom(newScale));
}

export const handleSetPosition = (callback) => {
    const oldPosition = store.getState()[TOPOLOGY_ROOM].graph.state.position
    const newPosition = callback(ObjectClone(oldPosition))
    store.dispatch(setPosition((newPosition)));
}

export const handleSetChecked = (choices) => {
    return (id) => {
        const filterStatus = store.getState()[TOPOLOGY_ROOM].graph.filter;
        const graph = store.getState()[TOPOLOGY_ROOM].graph;

        if (!id || id === -1) {
            const isCheckAll = choices.length === filterStatus.length || id === -1;
            store.dispatch(setTopologyGraphData(ObjectClone(
                {
                    ...graph.data,
                    nodes: graph.data.nodes.map((node) => ({
                        ...node,
                        isSelected: !isCheckAll,
                    })),
                }
            )))
            store.dispatch(setTopologyGraphFilter(!isCheckAll ? choices : []))
        } else {
            id--;
            const label = choices[id];
            const isChecked = filterStatus.includes(label);

            if (isChecked) id = filterStatus.indexOf(label);

            store.dispatch(setTopologyGraphData(ObjectClone(
                {
                    ...graph.data,
                    nodes: graph.data.nodes.map((node) => {
                        return {
                            ...node,
                            isSelected:
                                node.status === label
                                    ? !isChecked
                                    : node.isSelected,
                        }
                    })
                }
            )))

            store.dispatch(setTopologyGraphFilter(
                isChecked ? filterStatus.filter((x) => x !== label) : [...filterStatus, label]
            ))
        }
    }
}

export const linkDirectionalParticleWidth = (link) => {
    return link.color === "#fffff0" ? 2.8 : 0
}